var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-hyperlink",class:{
       'c-hyperlink--button' : _vm.isButton
   },attrs:{"target":_vm.domainObject.linkTarget,"href":_vm.url}},[_c('span',{staticClass:"c-hyperlink__label"},[_vm._v(_vm._s(_vm.domainObject.displayText))])])}
var staticRenderFns = []

export { render, staticRenderFns }